import gql from "graphql-tag";

export const REPROCESS_ERRORS = gql`
	mutation ReprocessErrors ($mailSetId: UUID!) {
		reprocessErrors (input: {mailSetId: $mailSetId}) {
			success
			errors
		}
	}
`;
